<template>
  <div>
    <!-- header-->
    <headertop></headertop>

    <div class="main">
      <div class="title">
        <h1 class="left"><i class="el-icon-notebook-2"></i> 我的笔记</h1>
        <el-button round class="right" @click="down_note"><i class="el-icon-download"></i> 导出</el-button>
      </div>
      <!-- 搜索框 -->
      <el-input placeholder="请输入内容" prefix-icon="el-icon-search" @keyup.enter.native="search_click()" v-model.trim="note.search" style="width: 90%;margin: 0 5%;"></el-input>
      <!-- 表格 -->
      <el-table
        :data="note.list.slice((note.currentPage-1)*note.pageSize,note.currentPage*note.pageSize)"
        stripe style="width: 90%;margin: 0 5%;"
        fit
        @selection-change="select_note">
        <el-table-column min-width='140' type="selection"></el-table-column>
        <el-table-column prop="time" sortable label="时间">
        </el-table-column>
        <el-table-column prop="video" sortable label="视频名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="type_name" sortable label="视频分类" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="teacher" sortable label="讲师" show-overflow-tooltip>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <router-link :to="{path:'/minenodedetail',query:{num:scope.row.num,type:scope.row.type}}">
              <el-button type="text" size="small" icon="el-icon-view" >查看</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页-->
      <div class="block center">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="note.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="note.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="note.total">
        </el-pagination>
      </div>
    </div>


    <!-- footer -->
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../../components/index/public/NavHeader.vue';
  import Footer from '../../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        note: {
          list:[],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          search: '',
          select:{
            selected:[],
            local:[],
            public:[],
          },
        },
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      this.get_note();
    },
    methods: {
      search_click(){
        this.get_note()
      },
      get_note(){
        let _this=this;
        _this.axios.get('/v2/user/get_note',{
          params: {
            'keyword':_this.note.search
          }
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.note.list=res.data.data
              _this.note.total=res.data.data.length
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      select_note(val){
        this.note.select.selected=val
      },
      change_note_select(){
        let _this=this;
        for(let i=0;i<_this.note.select.selected.length;i++){
          if(_this.note.select.selected[i].hasOwnProperty('v_a_num')){
            _this.note.select.public.push(_this.note.select.selected[i].num)
          }else{
            _this.note.select.local.push(_this.note.select.selected[i].num)
          }
        }
      },
      down_note(){
        let _this=this;
        if(_this.note.select.selected.length==0){
          _this.$message.error('请选择笔记视频');return false;
        }
        _this.change_note_select()

        _this.axios.post('/v2/user/down_note',{data:_this.note.select},{responseType:'blob'}).then(function(res) {
          if(res.status=='200'){
            const blob = new Blob([res.data],{type: 'aplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
            const elink = document.createElement('a')
            elink.download = '笔记清单导出列表.xlsx';
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleClick(row) {
      },
      handleSizeChange(val) {
        this.note.currentPage = 1;
        this.note.pageSize = val;
      },
      handleCurrentChange(val) {
        this.note.currentPage = val;
      },
    },
  }
</script>

<style scoped>
  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Mine/Node/Minenode.vue